import * as React from 'react'
import { Button, Layout, Row, Col, Space } from 'antd'
import './styles.css'
import { useAppContext } from '../../utils/AppContext'
import { Content } from 'antd/lib/layout/layout'
import { LogoutOutlined } from '@ant-design/icons'
import ThemeToggle from '../ThemeToggle'
import { initializeTheme } from '../../utils/themeUtils'
const { Header: HeaderLayout } = Layout

export interface HeaderLayoutProps {
  children?: React.ReactNode
  title?: string
}

export default function Header(props: HeaderLayoutProps) {
  const { signOut } = useAppContext()

  React.useEffect(() => {
    initializeTheme()
  }, [])

  return (
    <HeaderLayout className="page-header-wrapper">
      <Content className="page-header-content">
        <Row align="middle">
          <Col span={20}>{props.children}</Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            <Space size="middle">
              <ThemeToggle />
              <Button
                onClick={signOut}
                icon={<LogoutOutlined />}
                className="header-logout-button"
                type="primary"
                size="middle">
                Logout
              </Button>
            </Space>
          </Col>
        </Row>
      </Content>
    </HeaderLayout>
  )
}
